import i18n from 'localization/index'

export const trans = (key, params = []) => i18n.t(key, params)



// WEBPACK FOOTER //
// ./src/utils/helpers/translation.js